import { TTagsManager } from '../../types/tag';
import { getTermsValue, setTerms } from '../../../../JsonQuery';
import { GARAGE_TYPES_MAP_VALUE_TO_LABEL } from './constants';
import { EGarageType } from '../../../../api-models/common/json_query';

const ID = 'garageTypes' as const;

export const garageTypeTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const garageTypes = getTermsValue('garage_type')(jsonQuery);

    if (garageTypes === null || garageTypes.includes(EGarageType.Any)) {
      return null;
    }

    return garageTypes.map(garageType => ({
      label: GARAGE_TYPES_MAP_VALUE_TO_LABEL[garageType],
      value: garageType.toString(),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const garageTypes = getTermsValue('garage_type')(jsonQuery);

    if (garageTypes === null) {
      return jsonQuery;
    }

    const nextGarageTypes = garageTypes.filter(garageType => String(garageType) !== removingTagValue);

    return setTerms('garage_type')(jsonQuery)(nextGarageTypes.length > 0 ? nextGarageTypes : [EGarageType.Any]);
  },
};
